import { Company } from '../../../types/company/Company'
import { MappingMatrixRow, MappingStats, SourceMap } from '../types'
import { findSourceMapRecords } from './findSourceMapRecords'

export const buildMappingMatrix = (
  companies: Company[],
  sourceMaps: SourceMap[]
): { rows: MappingMatrixRow[]; stats: MappingStats } => {
  const stats: MappingStats = { total: 0, complete: 0, missing: 0 }

  const rows: MappingMatrixRow[] = companies.map(owner => ({
    company: owner,
    cells: companies.map(counterparty => {
      if (owner.id === counterparty.id) {
        return { counterpartyId: counterparty.id, customer: false, supplier: false, isSelf: true }
      }

      const customerMatches = findSourceMapRecords(sourceMaps, owner.id, counterparty.id, 'Customer')
      const supplierMatches = findSourceMapRecords(sourceMaps, owner.id, counterparty.id, 'Supplier')
      const hasCustomer = customerMatches.length > 0
      const hasSupplier = supplierMatches.length > 0

      stats.total += 1
      if (hasCustomer && hasSupplier) stats.complete += 1
      else stats.missing += 1

      return { counterpartyId: counterparty.id, customer: hasCustomer, supplier: hasSupplier, isSelf: false }
    })
  }))

  return { rows, stats }
}
